<template>
  <div class="ui-info-tile" :class="tileClasses">
    <div v-if="hasLabel" class="ui-info-tile__label">
      <slot name="label">{{ $t(label) }}</slot>
    </div>
    <div class="ui-info-tile__value">
      <slot name="value">{{ value }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiInfoTile',
  props: {
    label: { type: String, default: '' },
    value: { type: [String, Number], default: '' },
    tone: { type: String, default: 'default' },
    emphasis: { type: Boolean, default: true },
    monospace: { type: Boolean, default: false }
  },
  computed: {
    hasLabel () {
      return Boolean(this.label || this.$slots.label)
    },
    tileClasses () {
      return [
        `is-${this.tone}`,
        {
          'is-emphasis': this.emphasis,
          'is-monospace': this.monospace,
          'has-no-label': !this.hasLabel
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-info-tile {
  min-width: 0;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: var(--ui-space-md);
  border: 1px solid var(--ui-border-color-subtle);
  border-radius: var(--ui-radius-medium);
  background: rgba(var(--ui-bg-elevated-rgb), .28);
  box-sizing: border-box;
}

.ui-info-tile__label {
  margin-bottom: var(--ui-space-xs);
  color: var(--ui-text-secondary);
  font-size: var(--ui-font-size-caption);
  line-height: 20px;
}

.ui-info-tile__value {
  min-width: 0;
  color: var(--ui-text-primary);
  font-size: var(--ui-font-size-body);
  line-height: 24px;
  overflow-wrap: anywhere;
}

.ui-info-tile.is-emphasis .ui-info-tile__value {
  font-weight: var(--ui-font-weight-bold);
}

.ui-info-tile.is-monospace .ui-info-tile__value {
  font-family: Consolas, "SFMono-Regular", monospace;
}

.ui-info-tile.has-no-label {
  justify-content: center;
}

.ui-info-tile.is-primary .ui-info-tile__value,
.ui-info-tile.is-success .ui-info-tile__value { color: var(--ui-color-primary); }
.ui-info-tile.is-warning .ui-info-tile__value { color: var(--ui-color-warning); }
.ui-info-tile.is-danger .ui-info-tile__value { color: var(--ui-color-danger); }
.ui-info-tile.is-accent .ui-info-tile__value { color: var(--ui-color-accent); }
</style>
